import { useAppSelector, useAppTranslation } from "@/utils";
import { ActivationSteps } from "@payping/api/app/api/bnplMerchantTypes";
import { Divider, Flex, Grid, Progress, Steps, Typography } from "@payping/web-components";
import classNames from "classnames";
import { selectAtom } from "jotai/utils";
import { FC, useMemo } from "react";
import { installmentPaymentAtom } from "../../../state";
import { useAtom } from "jotai";

const activationStepAtom = selectAtom(installmentPaymentAtom, (val) => val.bnplActivationStep);

const BnplActivationPageFormLayoutSteps: FC = () => {
  const { t } = useAppTranslation();
  const { lg } = Grid.useBreakpoint();

  const [activationStepSate] = useAtom(activationStepAtom);

  const contract = useAppSelector((state) => state.bnplMerchant.contract);

  const currentStep = useMemo(() => {
    if (activationStepSate === ActivationSteps.SetWalletCreditAmount) {
      return 0;
    }
    if (activationStepSate === ActivationSteps.CompleteMerchantProfileInfo) {
      return 1;
    }
    if (activationStepSate === ActivationSteps.UploadSignature) {
      return 2;
    }
    // if (activationStep === ActivationSteps.AcceptRegulations) {
    //   return 3;
    // }
    return 0;
  }, [activationStepSate]);

  const items = [
    {
      title: t("shop.bnpl.activation.formDrawer.steps.initSettings.title"),
      description: (
        <Typography.Text type="secondary">
          {t("shop.bnpl.activation.formDrawer.steps.initSettings.description")}
        </Typography.Text>
      ),
    },
    {
      title: t("shop.bnpl.activation.formDrawer.steps.informationCompleting.title"),
      description: (
        <Typography.Text type="secondary">
          {t("shop.bnpl.activation.formDrawer.steps.informationCompleting.description")}
        </Typography.Text>
      ),
    },
  ];

  if (!contract?.hasValidSignature) {
    items.push({
      title: t("shop.bnpl.activation.formDrawer.steps.signature.title"),
      description: (
        <Typography.Text type="secondary">
          {t("shop.bnpl.activation.formDrawer.steps.signature.description")}
        </Typography.Text>
      ),
    });
  }
  const listLength = items.length * 60;

  return (
    <>
      <Flex
        className={classNames({
          "tw-min-w-[calc(272px+4rem)]": lg,
          "tw-w-full": !lg,
        })}
        vertical={!lg}
      >
        <Flex vertical={!lg} gap={"large"} className="tw-w-full tw-p-4 lg:tw-p-8">
          {lg ? (
            <Steps
              className="tw-w-full"
              style={{
                height: `${listLength}px`,
              }}
              status="process"
              responsive
              size="small"
              // because first step is 2
              current={currentStep}
              direction="vertical"
              items={items}
            />
          ) : (
            <>
              <Typography.Title level={5} className="!tw-m-0">
                {items[currentStep].title}
              </Typography.Title>
              <Progress
                status={"active"}
                percent={((currentStep + 1) / items.length) * 100}
                size="default"
                format={() => (
                  <div>
                    {t("shop.bnpl.activation.formDrawer.steps.currentLevel", {
                      current: currentStep + 1,
                      total: items.length,
                    })}
                  </div>
                )}
              />
            </>
          )}
        </Flex>
        <Divider
          className={classNames([
            "!tw-m-0 tw-mt-4",
            {
              "tw-h-full": lg,
              "tw-w-full": !lg,
            },
          ])}
          type={lg ? "vertical" : "horizontal"}
        />
      </Flex>
    </>
  );
};

export default BnplActivationPageFormLayoutSteps;
